import styled from 'styled-components';
import { colorSchema, media } from 'utils/style';

import NavBar from './NavBar';

export default styled(NavBar)`
  .navbar {
    background-color: ${colorSchema('white')};
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: sticky;
    width: 100%;
    top: 0;
    z-index: 5;

    ${media.greaterThan('tablet')`
      border-bottom: 1px solid ${colorSchema('grey200')};
      flex-wrap: nowrap;
      height: 56px;
      overflow: visible;
      position: fixed;
      z-index: 5;
    `}

    &--login {
      background-color: ${colorSchema('primary')};
      height: 4px;
    }

    &__brand {
      align-items: center;
      display: flex;
      justify-content: center;
      margin: 1rem 0;
      padding: 0 2rem;

      ${media.greaterThan('tablet')`
        margin: 0;
      `}

      svg {
        fill: ${colorSchema('primary')};
      }
    }

    &__collapse {
      background: #f9f9f9;
      border-top: 1px solid gray;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100vh;
      left: 0;
      top: 0;
      margin-top: 64px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      transition: transform 500ms ease;
      transform: translate3d(-100%, 0, 0);
      width: 100%;
      z-index: 6;

      ${media.greaterThan('tablet')`
        background: none;
        border: 0;
        flex-direction: row;
        height: auto;
        margin: 0;
        overflow: visible;
        padding: 0;
        position: relative;
        transition: none;
        left: auto;
        top: auto;
        width: 100%;
        transform: none;
      `}

      &--open {
        transform: translate3d(0, 0, 0);
      }
    }

    &__nav {
      display: flex;
      flex-direction: column;
      margin-right: auto;
      width: 100%;

      ${media.greaterThan('tablet')`
        flex-direction: row;
        margin-left: 5rem;
        justify-content: space-between;
        margin-right: 0;
      `}
    }

    &__link {
      align-items: flex-start;
      border-bottom: 1px solid ${colorSchema('gray900')};
      display: flex;
      opacity: 0.5;
      padding: 1rem 0 1rem 3rem;
      justify-content: flex-start;
      width: 100%;

      ${media.greaterThan('tablet')`
        align-items: center;
        border: 0;
        height: 100%;
        justify-content: center;
        margin-right: 2rem;
        opacity: 1;
        padding: 0;
        width: auto;
      `}

      &--active {
        ${media.greaterThan('tablet')`
          font-weight: bold;
          position: relative;

          &:after {
            border-bottom: 4px solid ${colorSchema('primary')};
            bottom: 0;
            content: "";
            left: 0;
            position: absolute;
            width: 100%;
          }
        `}
      }

      &--pod {
        position: relative;

        &:before {
          background-color: ${colorSchema('error900')};
          border-radius: 50%;
          content: '';
          position: absolute;
          left: -15px;
          height: 8px;
          width: 8px;
        }
      }
    }

    &__user-container {
      align-items: center;
      display: flex;
      height: 100%;
      padding: 1rem;
      position: relative;
      justify-content: flex-end;

      ${media.greaterThan('tablet')`
        justify-content: center;
        margin: 0 2rem 0;
        min-width: 12.3rem;
        width: auto;
      `}

      button {
        color: ${colorSchema('greyGorilla')};
        font-size: 1.6rem;
        font-weight: normal;
      }
    }

    &__help-button {
      padding-left: 0;
      width: 170px;
      display: none;

      ${media.greaterThan('tablet')`
        display: block;
      `}
    }

    &__dropdown-button {
      display: none;
      padding: 0;
      width: 175px;

      ${media.greaterThan('tablet')`
        display: block;
      `}
    }

    &__nav-container {
      display: flex;
      flex-direction: column;

      ${media.greaterThan('tablet')`
        flex-direction: row;
      `}
    }

    &__tel-icon {
      margin-right: 0.5rem;

      svg {
        fill: ${colorSchema('greyGorilla')};
      }
    }

    &__tel-link {
      color: ${colorSchema('greyGorilla')};

      &:hover {
        text-decoration: underline;
      }
    }

    &__opener {
      align-items: center;
      background: ${colorSchema('white')};
      border: 2px solid ${colorSchema('primary')};
      border-radius: 4px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      margin: 1rem;
      padding: 8px;

      svg {
        fill: ${colorSchema('primary')};
      }

      ${media.greaterThan('tablet')`
        display: none;
      `}
    }

    &__user-dropdown {
      height: auto;
      list-style: none;
      margin: 0;
      padding: 0;

      &-header {
        color: ${colorSchema('grey800')};
        padding: 1rem;
        font-weight: 500;
        border-bottom: 1px solid ${colorSchema('grey300')};
      }
    }

    &__user-dropdown-item {
      border-bottom: 1px solid ${colorSchema('grey300')};
      cursor: pointer;
      display: flex;
      padding-left: 2rem;

      ${media.greaterThan('tablet')`
        padding: 0;
      `}

      &:last-of-type {
        ${media.greaterThan('tablet')`
          border: 0;
        `}
      }

      &:hover {
        background-color: ${colorSchema('grey100')};
      }
    }

    &__user-dropdown-header {
      display: none;

      ${media.greaterThan('tablet')`
        display: flex;
      `}
    }

    &__user-dropdown-button {
      color: ${colorSchema('grey900')};
      font-size: 1.6rem;
      padding: 0 1rem;
      width: 100%;

      ${media.greaterThan('tablet')`
        font-size: 1.4rem;
      `}

      .btnWrapper {
        justify-content: left;
      }

      &:hover {
        text-decoration: none;
      }
    }

    &__docs-help-link {
      align-items: center;
      color: ${colorSchema('grey800')};
      margin-right: 2rem;
      display: flex;
      font-size: 1.6rem;
      font-weight: 500;

      &:hover {
        color: ${colorSchema('primary500')};
      }
    }
  }
`;
